import React from 'react';

const Topics = () => {
    return (
        <div>
           <h1>Topics........................................</h1> 
        </div>
    );
};

export default Topics;